// Who is holding unsaved work, asked at the moment something is about to destroy it. PULL, NOT PUSH:
// a surface registers a function the page calls, because a pushed copy goes stale at whichever site
// was forgotten. docs/specs/2026-09-18-revision-selection.md#switching-remounts-and-the-mechanism-matters
export default function createUnsavedWorkRegistry() {
  const reporters = new Map();

  return {
    register(key, reporter) {
      reporters.set(key, reporter);
    },

    // Takes the reporter as well as the key: a remount re-registers under the same key, and an
    // unregister that ignored WHICH reporter it held would delete the fresh registration the day
    // React's order changed, leaving the page believing there is nothing to lose.
    unregister(key, reporter) {
      if (reporters.get(key) === reporter) {
        reporters.delete(key);
      }
    },

    /** The keys of the surfaces that say they are holding unsaved work, in registration order. */
    pending() {
      return [...reporters.entries()].filter(([, reporter]) => !!reporter()).map(([key]) => key);
    },
  };
}
